import { MARQUEE_ITEMS } from "../data/site";

export const Marquee = () => {
    const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div data-testid="editorial-marquee" className="relative border-y border-lakou-gold/15 bg-lakou-coal/70 py-5 overflow-hidden select-none">
            <div className="animate-marquee flex whitespace-nowrap w-max">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center">
                        <span className={`font-display font-extrabold text-2xl sm:text-3xl tracking-tight px-6 ${i % 2 === 0 ? "text-lakou-cream" : "text-stroke-gold"}`}>
                            {item}
                        </span>
                        <span className={`w-2.5 h-2.5 rotate-45 ${i % 3 === 0 ? "bg-lakou-orange" : i % 3 === 1 ? "bg-lakou-gold" : "bg-lakou-terra"}`} />
                    </span>
                ))}
            </div>
        </div>
    );
};
